<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9625 7.41667C10.3963 7.41667 9.12669 8.68628 9.12669 10.2524C9.12669 11.8186 10.3963 13.0882 11.9625 13.0882C13.5286 13.0882 14.7982 11.8186 14.7982 10.2524C14.7982 8.68628 13.5286 7.41667 11.9625 7.41667ZM7.29336 10.2524C7.29336 7.67376 9.38378 5.58333 11.9625 5.58333C14.5411 5.58333 16.6316 7.67376 16.6316 10.2524C16.6316 12.8311 14.5411 14.9215 11.9625 14.9215C9.38378 14.9215 7.29336 12.8311 7.29336 10.2524Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7015 13.0258C13.8278 12.5355 14.3276 12.2404 14.8178 12.3667C16.8505 12.8902 18.2698 14.0824 18.8951 15.9592C19.0755 16.5007 19.1878 17.4487 19.2562 18.445L19.2583 18.4764V19.7917C19.2583 20.2979 18.8479 20.7083 18.3416 20.7083C17.8354 20.7083 17.425 20.2979 17.425 19.7917V18.5395C17.355 17.5368 17.2511 16.8249 17.1558 16.5387C16.756 15.3388 15.8845 14.5346 14.3606 14.1421C13.8703 14.0158 13.5752 13.516 13.7015 13.0258Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2186 13.0258C10.0923 12.5355 9.59254 12.2404 9.10228 12.3667C7.06963 12.8902 5.65027 14.0824 5.02499 15.9592C4.84399 16.5025 4.73688 17.4532 4.66887 18.444L4.66671 18.4754V19.7917C4.66671 20.2979 5.07712 20.7083 5.58338 20.7083C6.08964 20.7083 6.50005 20.2979 6.50005 19.7917V18.5384C6.57027 17.5305 6.66961 16.8231 6.76434 16.5387C7.16411 15.3388 8.03558 14.5346 9.55953 14.1421C10.0498 14.0158 10.3449 13.516 10.2186 13.0258Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'AccountOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
